import React, { useContext, useEffect, useState } from "react";
import {Button, ButtonGroup, Col, Container, Row, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import ColGenre from "../../components/columns/ColGenre";
import { Context } from "../../index";
import {
    fetchAssignmentsFullInfo, fetchAssTypes,
    fetchGenre,
    fetchLanguages,
    fetchPrices
} from "../../http/bookAPI";
import AssignLibraryList from "../../components/assignmentpages/AssignLibraryList";
import { observer } from "mobx-react-lite";
import Pages from "../../components/filters/pages";
import PriceFiltrG from "../../components/filters/PriceFiltrG";
import TypeAssFiltrG from "../../components/filters/TypeAssFiltrG";
import SortAssignsG from "../../components/filters/SortAssignsG";
import Loader from "../../components/Loader";
import LangFiltrDropDown from "../../components/filters/LangFiltrDropDown"; // Импортируем наш лоадер
import { Offcanvas } from "react-bootstrap";
import AccountSuspendedAlert from "../../components/AccountSuspendedAlert";
import SEO from "../../components/seo/SEO";
import AssignmentBookSearch from "../../components/filters/AssignmentBookSearch";
import {LIBRARY_ROUTE} from "../../utils/consts";

const DESKTOP_ASSIGN_VIEW_MODE_KEY = "assignDesktopViewMode";
const getInitialViewMode = () =>
    window.innerWidth < 480 ? "cards3" : (localStorage.getItem(DESKTOP_ASSIGN_VIEW_MODE_KEY) || "cards4");

const AssignLibrary = observer(() => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);
    const [loading, setLoading] = useState(true); // Состояние загрузки
    const isMobile = window.innerWidth < 480; // или useMediaQuery
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [viewMode, setViewMode] = useState(getInitialViewMode);
    let [onlyMine, setOnlyMine] = useState(false);
    let [freePromo, setFreePromo] = useState(false); // Состояние для freePromo
    const [hoveredPromotion, setHoveredPromotion] = useState(false);
    const isSuspended = user.user?.tariff_plan === "SUSPENDED";
    const [blockInfo, setBlockInfo] = useState(null);
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
const type = 'book';

// 🔥 NEW: warning по free-ревью
    const [freeReviewsWarning, setFreeReviewsWarning] = useState(false);
    const [freeReviews10dCount, setFreeReviews10dCount] = useState(0);

    const handleViewModeChange = (val) => {
        setViewMode(val);
        localStorage.setItem(DESKTOP_ASSIGN_VIEW_MODE_KEY, val);
    };






    useEffect(() => {
        let cancelled = false;
        setLoading(true); // Включаем лоадер перед загрузкой
        book.setAssignments([]);

        Promise.all([
            fetchGenre({ userId: user?.user?.id }).then(data => book.setGenres(data)),
            fetchPrices().then(data => book.setPrices(data)),
            fetchLanguages().then(data => book.setLanguages(data)),
            fetchAssTypes().then(data => book.setAssTypes(data)),
            fetchAssignmentsFullInfo(
                book.selectedGenre.id,
                book.selectedLanguage.id,
                book.selectedPrice.id,
                book.selectedAssType.id,
                book.page, book.limit,
                user?.user?.id,
                onlyMine, freePromo, type, searchTerm,
            ).then(data => {
                if (cancelled) return;
                if (data?.blocked) {
                    setBlockInfo(data);
                    book.setAssignments([]);
                    book.setTotalCount(0);
                } else {
                    setBlockInfo(null);
                    book.setAssignments(data.rows);
                    book.setTotalCount(data.count);
                }
                // 🔥 NEW: независимо от blocked забираем триггеры с сервера
                setFreeReviewsWarning(Boolean(data?.free_reviews_warning));
                setFreeReviews10dCount(Number(data?.free_reviews_10d_count || 0));
            })
        ])
            .catch(error => {
                if (cancelled) return;
                console.error('Error:', error);
            })
            .finally(() => {
                if (cancelled) return;
                setLoading(false); // Выключаем лоадер после загрузки
            });

        return () => {
            cancelled = true;
        };
    }, [book.page, book.selectedGenre, book.selectedLanguage, book.selectedPrice, book.selectedAssType, user.user.id, onlyMine, freePromo, searchTerm]);

    useEffect(() => {
        if (isMobile) {
            setViewMode("cards3");
        } else {
            const saved = localStorage.getItem(DESKTOP_ASSIGN_VIEW_MODE_KEY);
            if (saved) {
                setViewMode(saved);
            } else {
                setViewMode("cards4");
                localStorage.setItem(DESKTOP_ASSIGN_VIEW_MODE_KEY, "cards4");
            }
        }
    }, [isMobile]);


    useEffect(() => {
        if (blockInfo?.blocked) setShowMobileMenu(false);
    }, [blockInfo?.blocked]);

    const resetFilters = () => {
        setOnlyMine(false);
        setFreePromo(false);
        book.setSelectedGenre({});
        book.setSelectedLanguage({});
        book.setSelectedPrice({});
        book.setSelectedAssType({});
        setSearchInput("");
        setSearchTerm("");
        book.setPage(1);
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
        book.setPage(1);
    };


    return (
        <Container fluid style={{ padding: 30, marginTop: -48 }}>
            {isSuspended ? (

                    <AccountSuspendedAlert />

            ) : (
                <>
                    <SEO
                        url="https://virtalibry.com"
                        canonical="https://virtalibry.com"
                        organization={{
                            name: "Virtalibry",
                            url: "https://virtalibry.com",
                            logo: "https://virtalibry.com/face/why_love_is_gold_new.png",
                            sameAs: ["https://twitter.com/virtalibry"],
                            contactPoint: [{ "@type": "ContactPoint", contactType: "customer support", email: "info@virtalibry.com" }],
                        }}
                        breadcrumb={[
                            { name: "Virtalibry Home", item: "https://virtalibry.com" },
                            { name: "Library", item: "https://virtalibry.com/library" },
                        ]}

                    />
            <Row className="mt-2">
                <Col md={2} className="d-none d-md-block">
                  <AssignmentBookSearch
                      value={searchInput}
                      onChange={setSearchInput}
                      onSearch={handleSearch}
                      type={type}
                  />
                  <div className="mt-4">
                      <ColGenre />
                  </div>
                </Col>
                <Col md={10}>

                    {blockInfo?.blocked && (
                        <Row className="justify-content-center mt-5">
                            <Col xs={12} md={8}>
                                <div className="border border-secondary rounded p-3 mb-3 bg-light">
                                    <div className="d-flex align-items-center mb-1">

                                        <h5 className="mb-0">{blockInfo.title || 'Access temporarily limited'}</h5>
                                    </div>

                                    <p className="mb-2">{blockInfo.message}</p>

                                    {blockInfo.until_iso && (
                                        <p className="mb-2 small text-muted">
                                            Unlocks approximately:&nbsp;
                                            <strong>{new Date(blockInfo.until_iso).toLocaleString()}</strong>
                                        </p>
                                    )}

                                    {blockInfo.action_hint && (
                                        <p className="mb-0 small">
                                            <em>{blockInfo.action_hint}</em>
                                        </p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}

                    {blockInfo?.blocked ? null :
                    <Row className="g-0 mb-2 ">
                        {isMobile ? (
                            // 🔹 Мобильная версия — кнопка Offcanvas + сортировка в одну строку
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className="me-0 ms-0">
                                    <SortAssignsG />
                                </div>
                                <div className="ms-1 me-2" style={{ maxWidth: '120px', fontSize: '0.85em' }}>
                                    <TypeAssFiltrG />
                                </div>

                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    onClick={() => setShowMobileMenu(true)}
                                > <i className="bi bi-list ms-0 me-2"></i>Filters
                                </Button>
                            </div>
                        ) : (
                            // 🔹 Десктоп: всё как раньше
                            <>

                                <Col xs={4} sm={2} md={1} className="ms-0 d-none d-md-block"><SortAssignsG /></Col>

                                <Col xs={6} sm={4} md={6} className="d-none d-md-block">
                                    <div className="d-flex flex-wrap align-items-center">
                                    <Button
                                        title="Show Free Promotion Assignments"
                                        className="mx-1 d-flex btn-sm mb-2 align-items-center justify-content-start fw-semibold"
                                        style={{
                                            transition: "transform 0.2s",
                                            transform: hoveredPromotion || freePromo ? "scale(1.1)" : "scale(1)",
                                        }}
                                        variant={freePromo ? "secondary" : "outline-secondary"}
                                        onMouseEnter={() => setHoveredPromotion(true)}
                                        onMouseLeave={() => setHoveredPromotion(false)}
                                        onClick={() => {
                                            setFreePromo((prev) => !prev);
                                            book.setSelectedPrice({});
                                            book.setSelectedAssType({});
                                        }}
                                    >
                                        Free Promotion
                                    </Button>
                                    <PriceFiltrG />
                                    </div>
                                </Col>



                                <Col xs={6} sm={2} md={3} className="px-2 d-none d-md-block">
                                    <div className="d-flex flex-wrap align-items-center gap-3">
                                    <TypeAssFiltrG />
                                        <LangFiltrDropDown />
                                    </div>

                                </Col>

                                <Col xs={2} sm={2} md={1} className="px-2 d-none d-md-block">
                                    <ButtonGroup size="sm" className="w-100">
                                        <Button
                                            title="Show only my assignments"
                                            variant={onlyMine ? "success" : "outline-secondary"}
                                            onClick={() => setOnlyMine(prev => !prev)}
                                            className="fw-semibold"
                                        >
                                            Mine
                                        </Button>
                                        <Button
                                            title="Reset all filters"
                                            variant="outline-secondary"
                                            onClick={resetFilters}
                                            className="fw-semibold"
                                        >
                                            Clear
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                                <Col xs={6} sm={1} md={1} className="px-2 d-none d-md-block">
                                    <ToggleButtonGroup
                                        type="radio"
                                        name="assignViewMode"
                                        value={viewMode}
                                        onChange={handleViewModeChange}
                                        size="sm"
                                    >
                                        <ToggleButton id="view-3cards" variant="outline-success" value="cards3">
                                            x3
                                        </ToggleButton>
                                        <ToggleButton id="view-4cards" variant="outline-success" value="cards4">
                                            x4
                                        </ToggleButton>
                                        <ToggleButton id="view-table" variant="outline-success" value="table">
                                            📋
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Col>
                            </>
                        )}
                    </Row>
                    }
                    {freeReviewsWarning && (
                        <div
                            className="alert alert-warning border border-secondary mt-0 ms-0 me-1 mb-2"
                            style={{
                                fontSize: "0.9rem",
                                lineHeight: 1.4,
                            }}
                        >
                            <h6 className="fw-semibold mb-1">
                                Too many free assignments in a short time
                            </h6>
                            <p className="mb-1">
                                In the last 10 days you have completed{" "}
                                <b>{freeReviews10dCount}</b> free reviews
                                (Universal / Kindle Unlimited / Free-price offers).
                            </p>
                            <p className="mb-1">
                                Posting a lot of free reviews in a short period is very risky for your Amazon
                                customer account. Amazon may flag your profile, hide or remove your reviews,
                                and other users may file complaints if their reviews disappear.
                                To protect you and the community, we are temporarily hiding free assignments
                                and will show you only paid offers. Paid reviews look more natural to Amazon and
                                reduce the risk of filters and bans.
                            </p>
                            <p className="mb-0 small text-muted">
                                Please take care of your account and don’t behave like a “review machine gun”.
                                Slow down, mix paid and free offers, and let your review history look natural.
                                A very good practice is to occasionally grab free-promo books directly on the Amazon
                                store — for example in categories like Fantasy or Cooking — and open them in your
                                Kindle reader. You don’t need to read them fully and you should NOT leave a rating
                                or a review. This simple habit makes your profile look more natural and significantly
                                improves the long-term survival of your real reviews.
                                <br />
                                {/* TODO: вставь реальную ссылку на статью */}
                                {/*   Read more:{" "}
                                <a
                                    href="/help/amazon-free-reviews-safety"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Why abusing free reviews can be dangerous
                                </a>*/}
                            </p>
                        </div>
                    )}
                    <Row>
                        <Col xs={12} sm={12} md={12} className="ms-0"><h1 className="fs-6"></h1></Col>
                    </Row>

                    <Row className="d-flex justify-content-center p-0" style={{ marginTop: -7 }}>

                        {blockInfo?.blocked ? null : (
                            loading
                                ? <Loader />
                                : <AssignLibraryList viewMode={viewMode} returnRoute={LIBRARY_ROUTE} />
                        )}
                    </Row>
                    <Row className="d-flex justify-content-start">
                        {loading || blockInfo?.blocked ? '' : <Pages />}
                    </Row>
                </Col>
            </Row>
            {!blockInfo?.blocked && (
            <Offcanvas show={showMobileMenu} onHide={() => setShowMobileMenu(false)} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filter & Sort</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="d-grid gap-3">
                        <AssignmentBookSearch
                            value={searchInput}
                            onChange={setSearchInput}
                            onSearch={handleSearch}
                            type={type}
                        />

                        <PriceFiltrG />

                        <LangFiltrDropDown />

                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => {
                                setShowMobileMenu(false);
                              //  fetchData(); // 👈 перезагружаем данные с фильтрами
                            }}
                            className="mt-3"
                        >
                            Apply Filters
                        </Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            )}
               </>
                )}
        </Container>

    );
});

export default AssignLibrary;
